import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import Vue from 'vue'
import App from './App.vue'
import jQuery from 'jquery'
import Vuelidate from "vuelidate";

global.$ = jQuery

Vue.component('Panel', 
    () => import('./components/Panel.vue')
)
Vue.config.productionTip = false
Vue.use(Vuelidate);

new Vue({
  render: h => h(App),
}).$mount('#app')
